// extracted by mini-css-extract-plugin
export default {"loaderContainer":"spinner_loaderContainer__Xjv3s","loader":"spinner_loader__7-zPc","rotation":"spinner_rotation__umZuc"};